import { BurningWeaponEffect } from 'game/extended/heros/mage/burning_weapon/burning_weapon_effect'

export default {
    events: {},
    effects: {
        BurningWeaponEffect
    },
    requirements: {}
}